import boot from '$boot/boot';
import pageComponent from './index';
import language from './language';
import filters from '$common/utils/filters';
import DocumentTitlePlugin from '$common/utils/vue-plugin/document-title';
import DocumentMixin from '$common/utils/vue-plugin/mixins/document-mixin';
import RecalcMixin from '$common/utils/vue-plugin/mixins/recalc-mixin';
import ToolMixinMixin from '$common/utils/vue-plugin/mixins/tool-mixin';
import routerModule from './router';
import store from './store';
import Nprogress from 'nprogress'
import 'nprogress/nprogress.css';
import Viewer from 'v-viewer';
import 'viewerjs/dist/viewer.css';
import moment from "./utils/momen";
import Avue from '@smallwei/avue';
import '@smallwei/avue/lib/index.css';
import util from "./utils/util";
import '$common/style/reset.styl';
import 'default-passive-events';
import bossBreadcrumb from '$merchantComponent/layout/home/boss-breadcrumb'

const { i18n } = language.use(Vue, VueI18n);
const router = routerModule.use(Vue, VueRouter)
Nprogress.configure({ easing: 'ease', speed: 500 })
Vue.component(bossBreadcrumb.name, bossBreadcrumb)
Vue.use(Vuex).use(Viewer).use(moment).use(filters).use(DocumentTitlePlugin)
  .use(Avue, { menuType: 'button', size: 'mini', locale: i18n.locale, i18n: (key, value) => i18n.t(key, value) })
Vue.prototype.$util = util
boot({
  Vue,
  pageComponent,
  before: config => Object.assign({}, config, {
    i18n,
    router,
    store,
    mixins: [DocumentMixin, RecalcMixin, ToolMixinMixin]
  })
});
